import React from 'react';
import PageHero from '../components/PageHero';
import PageBlocks, { usePageBlocks } from '../components/PageBlocks';
import BoardSection from '../components/sections/BoardSection';
import { useTranslation } from '../i18nContext';

export default function ConsejoDirectivoPage() {
  const t = useTranslation();
  const { blocks } = usePageBlocks('board');
  return (
    <>
      <PageHero label={t.about.presLabel} title={t.locale === 'es' ? 'Consejo Directivo' : 'Board of Directors'} />
      {blocks.length > 0 ? <PageBlocks pageKey="board" /> : <BoardSection />}
    </>
  );
}
